
// const api = import.meta.env.VITE_API_URL || 'http://localhost:7000';

// const BASE_URL = `${api}/api/v1/manufacturing`;

// // ─────────────────────────────────────────────
// // TYPES
// // ─────────────────────────────────────────────

// export interface ProductionOrderPayload {
//   poNumber: string;
//   type: 'MTO' | 'MTS';
//   priority?: 'LOW' | 'NORMAL' | 'HIGH' | 'URGENT';

//   itemId: string;
//   plannedQty: number;

//   plannedStartDate: string;
//   plannedEndDate: string;

//   salesInvoiceId?: string;
//   warehouseId: string;
//   routingId?: string;

//   notes?: string;
// }

// export interface ProductionOrderResponse {
//   id: string;

//   po_number: string;

//   type: string;
//   status: string;
//   priority: string;

//   item_id: string;
//   item_name?: string;
//   item_code?: string;

//   bom_id: string;
//   bom_version: string;

//   planned_qty: number;
//   completed_qty: number;
//   rejected_qty: number;

//   planned_start_date: string;
//   planned_end_date: string;

//   actual_start_date?: string | null;
//   actual_end_date?: string | null;

//   sales_invoice_id?: string | null;

//   warehouse_id: string;
//   warehouse_name?: string;

//   routing_id?: string | null;

//   notes?: string | null;

//   created_by: string;
//   created_at: string;
// }

// export interface ApiResponse<T> {
//   success: boolean;
//   message?: string;
//   data?: T;
//   pagination?: {
//     page: number;
//     limit: number;
//     total: number;
//     totalPages: number;
//   };
// }

// export interface ProductionOrderFilterParams {
//   status?: string;
//   type?: string;
//   priority?: string;
//   warehouseId?: string;
//   search?: string;
//   page?: number;
//   limit?: number;
// }

// // ─────────────────────────────────────────────
// // AUTH HELPER
// // ─────────────────────────────────────────────

// function getAuthHeaders(): HeadersInit {
//   const token = localStorage.getItem('token');

//   return {
//     'Content-Type': 'application/json',
//     ...(token ? { Authorization: `Bearer ${token}` } : {}),
//   };
// }

// async function handleResponse<T>(
//   res: Response,
// ): Promise<ApiResponse<T>> {
//   const data = await res.json();

//   if (!res.ok) {
//     throw new Error(data?.message || 'Something went wrong');
//   }

//   return data as ApiResponse<T>;
// }

// // ─────────────────────────────────────────────
// // MAPPER
// // ─────────────────────────────────────────────

// export function mapApiToProductionOrder(r: any) {
//   return {
//     id: r.id,

//     poNumber: r.poNumber ?? r.po_number ?? '',

//     type: r.type ?? '',
//     status: r.status ?? '',
//     priority: r.priority ?? '',

//     itemId: r.itemId ?? r.item_id ?? '',
//     itemName: r.itemName ?? r.item_name ?? '',
//     itemCode: r.itemCode ?? r.item_code ?? '',

//     bomId: r.bomId ?? r.bom_id ?? '',
//     bomVersion: r.bomVersion ?? r.bom_version ?? '',

//     plannedQty: Number(r.plannedQty ?? r.planned_qty ?? 0),
//     completedQty: Number(r.completedQty ?? r.completed_qty ?? 0),
//     rejectedQty: Number(r.rejectedQty ?? r.rejected_qty ?? 0),

//     plannedStartDate:
//       r.plannedStartDate ?? r.planned_start_date ?? '',

//     plannedEndDate:
//       r.plannedEndDate ?? r.planned_end_date ?? '',

//     actualStartDate:
//       r.actualStartDate ?? r.actual_start_date ?? null,

//     actualEndDate:
//       r.actualEndDate ?? r.actual_end_date ?? null,

//     salesInvoiceId:
//       r.salesInvoiceId ?? r.sales_invoice_id ?? null,

//     warehouseId:
//       r.warehouseId ?? r.warehouse_id ?? '',

//     warehouseName:
//       r.warehouseName ?? r.warehouse_name ?? '',

//     routingId:
//       r.routingId ?? r.routing_id ?? null,

//     notes: r.notes ?? '',
//     createdBy: r.createdBy ?? r.created_by ?? '',
//     createdAt: r.createdAt ?? r.created_at ?? '',
//   };
// }

// // ─────────────────────────────────────────────
// // API CALLS
// // ─────────────────────────────────────────────

// export async function createProductionOrder(
//   payload: ProductionOrderPayload,
// ): Promise<ApiResponse<ProductionOrderResponse>> {
//   const res = await fetch(`${BASE_URL}/production-orders`, {
//     method: 'POST',
//     headers: getAuthHeaders(),
//     body: JSON.stringify(payload),
//   });

//   return handleResponse<ProductionOrderResponse>(res);
// }

// export async function getAllProductionOrders(
//   params?: ProductionOrderFilterParams,
// ): Promise<ApiResponse<ProductionOrderResponse[]>> {
//   const query = new URLSearchParams();

//   if (params?.status) query.set('status', params.status);
//   if (params?.type) query.set('type', params.type);
//   if (params?.priority) query.set('priority', params.priority);
//   if (params?.warehouseId)
//     query.set('warehouseId', params.warehouseId);
//   if (params?.search) query.set('search', params.search);
//   if (params?.page)
//     query.set('page', params.page.toString());
//   if (params?.limit)
//     query.set('limit', params.limit.toString());

//   const qs = query.toString();

//   const res = await fetch(
//     `${BASE_URL}/production-orders${qs ? `?${qs}` : ''}`,
//     {
//       method: 'GET',
//       headers: getAuthHeaders(),
//     },
//   );

//   return handleResponse<ProductionOrderResponse[]>(res);
// }

// export async function getProductionOrderById(
//   id: string,
// ): Promise<ApiResponse<ProductionOrderResponse>> {
//   const res = await fetch(
//     `${BASE_URL}/production-orders/${id}`,
//     {
//       method: 'GET',
//       headers: getAuthHeaders(),
//     },
//   );

//   return handleResponse<ProductionOrderResponse>(res);
// }

// export async function updateProductionOrder(
//   id: string,
//   payload: Partial<ProductionOrderPayload>,
// ): Promise<ApiResponse<ProductionOrderResponse>> {
//   const res = await fetch(
//     `${BASE_URL}/production-orders/${id}`,
//     {
//       method: 'PUT',
//       headers: getAuthHeaders(),
//       body: JSON.stringify(payload),
//     },
//   );

//   return handleResponse<ProductionOrderResponse>(res);
// }

// export async function deleteProductionOrder(
//   id: string,
// ): Promise<ApiResponse<null>> {
//   const res = await fetch(
//     `${BASE_URL}/production-orders/${id}`,
//     {
//       method: 'DELETE',
//       headers: getAuthHeaders(),
//     },
//   );

//   return handleResponse<null>(res);
// }

// // export async function duplicateProductionOrder(
// //   id: string,
// // ): Promise<ApiResponse<ProductionOrderResponse>> {
// //   const res = await fetch(
// //     `${BASE_URL}/production-orders/${id}/duplicate`,
// //     {
// //       method: 'POST',
// //       headers: getAuthHeaders(),
// //     },
// //   );

// //   return handleResponse<ProductionOrderResponse>(res);
// // }

// export async function updateProductionOrderStatus(
//   id: string,
//   status: string,
// ): Promise<ApiResponse<ProductionOrderResponse>> {
//   const res = await fetch(
//     `${BASE_URL}/production-orders/${id}/status`,
//     {
//       method: 'PATCH',
//       headers: getAuthHeaders(),
//       body: JSON.stringify({ status }),
//     },
//   );

//   return handleResponse<ProductionOrderResponse>(res);
// }




const api = import.meta.env.VITE_API_URL || 'http://localhost:7000';

const BASE_URL = `${api}/api/v1/manufacturing`;

// ─────────────────────────────────────────────
// TYPES
// ─────────────────────────────────────────────

export interface ProductionOrderPayload {
    poNumber?: string;
    po_number?: string;
    type: 'MTO' | 'MTS';
    status?: 'DRAFT' | 'PLANNED' | string;
    priority?: 'LOW' | 'NORMAL' | 'HIGH' | 'URGENT';

    itemId: string;
    plannedQty: number;

    plannedStartDate: string;
    plannedEndDate: string;

    bomId?: string;
    salesInvoiceId?: string;
    salesOrderId?: string;
    warehouseId: string;
    routingId?: string;
    shiftId?: string;

    notes?: string;
}

export interface ProductionOrderResponse {
    id: string;

    po_number: string;

    type: string;
    status: string;
    priority: string;

    item_id: string;
    item_name?: string;
    item_code?: string;

    bom_id: string;
    bom_version: string;

    planned_qty: number;
    completed_qty: number;
    rejected_qty: number;

    planned_start_date: string;
    planned_end_date: string;

    actual_start_date?: string | null;
    actual_end_date?: string | null;

    sales_invoice_id?: string | null;

    warehouse_id: string;
    warehouse_name?: string;

    routing_id?: string | null;

    notes?: string | null;

    created_by: string;
    created_at: string;
}

export interface MaterialReservation {
    id: string;
    productionOrderId: string;
    itemId: string;
    itemName: string;
    itemCode: string;
    requiredQty: number;
    reservedQty: number;
    issuedQty?: number;
    stockAvailable?: number;
    totalPhysicalStock?: number;
    warehouseReservedQty?: number;
    warehouseName?: string;
    unit: string;
    status: 'PENDING' | 'PARTIAL' | 'RESERVED' | 'RELEASED' | 'ISSUED' | 'PARTIALLY ISSUED';
}

export interface ApiResponse<T> {
    success: boolean;
    message?: string;
    data?: T;
    pagination?: {
        page: number;
        limit: number;
        total: number;
        totalPages: number;
    };
}

export interface ProductionOrderFilterParams {
    status?: string;
    type?: string;
    priority?: string;
    warehouseId?: string;
    search?: string;
    page?: number;
    limit?: number;
}

// ─────────────────────────────────────────────
// AUTH HELPER
// ─────────────────────────────────────────────

function getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('token');

    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

async function handleResponse<T>(res: Response): Promise<ApiResponse<T>> {
    const data = await res.json();

    if (!res.ok) {
        throw new Error(data?.message || 'Something went wrong');
    }

    return data as ApiResponse<T>;
}

// ─────────────────────────────────────────────
// MAPPER
// ─────────────────────────────────────────────

export function mapApiToProductionOrder(r: any) {
    return {
        id: r.id,

        poNumber: r.poNumber ?? r.po_number ?? '',

        type: r.type ?? '',
        status: r.status ?? '',
        priority: r.priority ?? '',

        itemId: r.itemId ?? r.item_id ?? '',
        itemName: r.itemName ?? r.item_name ?? '',
        itemCode: r.itemCode ?? r.item_code ?? '',

        bomId: r.bomId ?? r.bom_id ?? '',
        bomVersion: r.bomVersion ?? r.bom_version ?? '',

        plannedQty: Number(r.plannedQty ?? r.planned_qty ?? 0),
        completedQty: Number(r.completedQty ?? r.completed_qty ?? 0),
        rejectedQty: Number(r.rejectedQty ?? r.rejected_qty ?? 0),

        plannedStartDate: r.plannedStartDate ?? r.planned_start_date ?? '',
        plannedEndDate: r.plannedEndDate ?? r.planned_end_date ?? '',

        actualStartDate: r.actualStartDate ?? r.actual_start_date ?? null,
        actualEndDate: r.actualEndDate ?? r.actual_end_date ?? null,

        salesInvoiceId: r.salesInvoiceId ?? r.sales_invoice_id ?? null,

        warehouseId: r.warehouseId ?? r.warehouse_id ?? '',
        warehouseName: r.warehouseName ?? r.warehouse_name ?? '',

        routingId: r.routingId ?? r.routing_id ?? null,
        routing_id: r.routing_id ?? r.routingId ?? null,

        workOrders: r.workOrders ?? r.work_orders ?? [],
        work_orders: r.work_orders ?? r.workOrders ?? [],

        qty_to_produce: Number(r.qty_to_produce ?? r.planned_qty ?? r.plannedQty ?? 0),
        completed_qty: Number(r.completed_qty ?? r.completed_qty ?? r.completedQty ?? 0),

        notes: r.notes ?? '',
        createdBy: r.createdBy ?? r.created_by ?? '',
        createdAt: r.createdAt ?? r.created_at ?? '',
    };
}

// ─────────────────────────────────────────────
// PRODUCTION ORDER CRUD
// ─────────────────────────────────────────────

export async function createProductionOrder(
    payload: ProductionOrderPayload,
): Promise<ApiResponse<ProductionOrderResponse>> {
    const res = await fetch(`${BASE_URL}/production-orders`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
    });

    return handleResponse<ProductionOrderResponse>(res);
}

export async function getAllProductionOrders(
    params?: ProductionOrderFilterParams,
): Promise<ApiResponse<ProductionOrderResponse[]>> {
    const query = new URLSearchParams();

    if (params?.status) query.set('status', params.status);
    if (params?.type) query.set('type', params.type);
    if (params?.priority) query.set('priority', params.priority);
    if (params?.warehouseId) query.set('warehouseId', params.warehouseId);
    if (params?.search) query.set('search', params.search);
    if (params?.page) query.set('page', params.page.toString());
    if (params?.limit) query.set('limit', params.limit.toString());

    const qs = query.toString();

    const res = await fetch(
        `${BASE_URL}/production-orders${qs ? `?${qs}` : ''}`,
        {
            method: 'GET',
            headers: getAuthHeaders(),
        },
    );

    return handleResponse<ProductionOrderResponse[]>(res);
}

export async function getProductionOrderById(
    id: string,
): Promise<ApiResponse<ProductionOrderResponse>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });

    return handleResponse<ProductionOrderResponse>(res);
}

export async function updateProductionOrder(
    id: string,
    payload: Partial<ProductionOrderPayload>,
): Promise<ApiResponse<ProductionOrderResponse>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
    });

    return handleResponse<ProductionOrderResponse>(res);
}

export async function deleteProductionOrder(
    id: string,
): Promise<ApiResponse<null>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });

    return handleResponse<null>(res);
}

export async function updateProductionOrderStatus(
    id: string,
    status: string,
): Promise<ApiResponse<ProductionOrderResponse>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}/status`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify({ status }),
    });

    return handleResponse<ProductionOrderResponse>(res);
}

// ─────────────────────────────────────────────
// MATERIAL RESERVATIONS
// ─────────────────────────────────────────────

export async function getMaterialReservations(
    productionOrderId: string,
): Promise<ApiResponse<MaterialReservation[]>> {
    const res = await fetch(
        `${BASE_URL}/production-orders/${productionOrderId}/reservations`,
        {
            method: 'GET',
            headers: getAuthHeaders(),
        },
    );

    return handleResponse<MaterialReservation[]>(res);
}

export async function reserveMaterial(
    productionOrderId: string,
    reservationId: string,
): Promise<ApiResponse<MaterialReservation>> {
    const res = await fetch(
        `${BASE_URL}/production-orders/${productionOrderId}/reservations/${reservationId}/reserve`,
        {
            method: 'POST',
            headers: getAuthHeaders(),
        },
    );

    return handleResponse<MaterialReservation>(res);
}

export async function releaseMaterial(
    productionOrderId: string,
    reservationId: string,
): Promise<ApiResponse<MaterialReservation>> {
    const res = await fetch(
        `${BASE_URL}/production-orders/${productionOrderId}/reservations/${reservationId}/release`,
        {
            method: 'POST',
            headers: getAuthHeaders(),
        },
    );

    return handleResponse<MaterialReservation>(res);
}

export async function reserveAllMaterials(
    productionOrderId: string,
): Promise<ApiResponse<MaterialReservation[]>> {
    const res = await fetch(
        `${BASE_URL}/production-orders/${productionOrderId}/reservations/reserve-all`,
        {
            method: 'POST',
            headers: getAuthHeaders(),
        },
    );

    return handleResponse<MaterialReservation[]>(res);
}

// ─────────────────────────────────────────────
// UNIFIED LIFECYCLE API CALLS
// ─────────────────────────────────────────────

export async function getFullProductionOrderDetails(id: string): Promise<ApiResponse<any>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}/full-details`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });
    return handleResponse<any>(res);
}

export async function confirmProductionOrder(id: string): Promise<ApiResponse<any>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}/confirm`, {
        method: 'POST',
        headers: getAuthHeaders(),
    });
    return handleResponse<any>(res);
}

/** POST /production-orders/:id/start — PLANNED → IN_PROGRESS */
export async function startProductionOrder(
    id: string,
    payload: {
        actual_start_date: string;
        shift_id?: string | null;
        warehouse_id?: string | null;
        supervisor_id?: string | null;
        notes?: string;
    },
): Promise<ApiResponse<any>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}/start`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
    });
    return handleResponse<any>(res);
}

/** POST /production-orders/:id/continue-production — work orders for the units still to be made */
export async function continueProduction(id: string): Promise<ApiResponse<any>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}/continue-production`, {
        method: 'POST',
        headers: getAuthHeaders(),
    });
    return handleResponse<any>(res);
}

export async function completeProductionOrderFlow(
    id: string,
    payload?: { outputBatchNumber?: string; warehouseId?: string },
): Promise<ApiResponse<any>> {
    const res = await fetch(`${BASE_URL}/production-orders/${id}/complete-flow`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload || {}),
    });
    return handleResponse<any>(res);
}

export async function getMaterialStockApi(params?: {
    warehouseId?: string;
    itemIds?: string[];
}): Promise<ApiResponse<{ data: any[]; stockMap: Record<string, number> }>> {
    const query = new URLSearchParams();
    if (params?.warehouseId) query.append('warehouse_id', params.warehouseId);
    if (params?.itemIds && params.itemIds.length > 0) {
        query.append('item_ids', params.itemIds.join(','));
    }
    const queryString = query.toString() ? `?${query.toString()}` : '';
    const res = await fetch(`${BASE_URL}/production-orders/material-stock${queryString}`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });
    return handleResponse<any>(res);
}
// ─────────────────────────────────────────────
// SCHEDULE CAPACITY CHECK
// Available / day = hours × efficiency × machines; Required = qty × time per unit (routing)
// ─────────────────────────────────────────────

export interface CapacityStage {
    stageNumber: number;
    stageName: string;
    basis: 'PER_UNIT' | 'PER_BATCH';
    batchSize: number;
    runMinutes: number;
    setupMinutes: number;
    minutes: number;
}

export interface CapacityDayEntry {
    isThisOrder: boolean;
    woNumber?: string;
    poNumber?: string;
    itemName?: string | null;
    qty: number;
    basis?: 'PER_UNIT' | 'PER_BATCH';
    batchSize?: number;
    runMinutes?: number | null;
    stages?: CapacityStage[];
    /** Minutes on this day (the work order's minutes spread over its working days) */
    minutes: number;
    spreadDays: number;
}

export interface CapacityWorkCenter {
    workCenterId: string;
    code: string;
    name: string;
    hoursPerDay: number;
    efficiencyPct: number;
    machineCount: number;
    capacityUnits: number;
    workingDays: string[];
    availableMinutesPerDay: number;
    availableHoursPerDay: number;
    stages: CapacityStage[];
    orderMinutes: number;
    orderDays: number;
    minDaysNeeded: number | null;
    overloaded: boolean;
    overloadedDays: string[];
    days: { date: string; existingMinutes: number; orderMinutes: number; totalMinutes: number; availableMinutes: number; overload: boolean }[];
    peakDay: { date: string; totalMinutes: number; availableMinutes: number; overload: boolean; entries: CapacityDayEntry[] } | null;
}

export interface ScheduleCapacityResult {
    orderQty: number;
    startDate: string;
    endDate: string;
    workCenters: CapacityWorkCenter[];
    overloaded: boolean;
    /** Earliest later start (same span) with no overloaded day */
    suggestion: { startDate: string; endDate: string; shiftDays: number } | null;
    /** Same start, earliest end date that fits — when the order is too big for its span */
    extendSuggestion: { startDate: string; endDate: string; extraDays: number } | null;
}

export async function getScheduleCapacity(params: {
    routingId: string;
    qty: number;
    startDate: string;
    endDate?: string;
    warehouseId?: string;
    excludeOrderId?: string;
}): Promise<ApiResponse<ScheduleCapacityResult>> {
    const query = new URLSearchParams({
        routing_id: params.routingId,
        qty: String(params.qty),
        start_date: params.startDate,
    });
    if (params.endDate) query.append('end_date', params.endDate);
    if (params.warehouseId) query.append('warehouse_id', params.warehouseId);
    if (params.excludeOrderId) query.append('exclude_order_id', params.excludeOrderId);
    const res = await fetch(`${BASE_URL}/production-orders/schedule-capacity?${query.toString()}`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });
    return handleResponse<ScheduleCapacityResult>(res);
}

// ─────────────────────────────────────────────
// STANDARD COST PLAN
// What `qty` units cost by BOM and routing, stage by stage. The same plan is saved on the order
// when it is created / confirmed and the order's Costing tab arrives at the same standard.
// ─────────────────────────────────────────────

export type PlanStageIssue = 'NO_WORK_CENTER' | 'NO_MACHINE' | 'NO_LABOUR_RATE' | 'NO_MACHINE_RATE' | 'NO_JOB_RATE';

export interface PlanStage {
    stageNumber: number;
    stageName: string;
    stageType: 'IN_HOUSE' | 'JOB_WORK';
    subcontractorName: string | null;
    workCenter: { id: string | null; code: string | null; name: string; type: string | null } | null;
    machine: { id: string | null; code: string | null; name: string; hourRate: number } | null;
    crew: number;
    basis: 'PER_UNIT' | 'PER_BATCH';
    batchSize: number;
    setupMinutes: number;
    runMinutes: number;
    /** Units (per unit) or batches (per batch) the run time is multiplied by */
    runs: number;
    /** Setup + run × runs, as the stage's work order is planned */
    plannedMinutes: number;
    labourHours: number;
    qcRequired: boolean;
    qcChecklistName: string | null;
    materialCount: number;
    labourRate: number;
    operatorPerHour: number;
    labourPerHour: number;
    machinePerHour: number;
    labourSource: 'WORK_CENTER' | 'AVG_OPERATOR_WAGE' | 'JOB_WORK';
    labourCost: number;
    machineCost: number;
    jobRate: number;
    jobWorkCost: number;
    cost: number;
    issues: PlanStageIssue[];
}

export interface PlanMaterial {
    itemId: string;
    itemName: string;
    itemCode: string | null;
    unit: string;
    qtyPerUnit: number;
    scrapPct: number;
    requiredQty: number;
    availableQty: number;
    rate: number;
    amount: number;
}

export interface StandardCostPlan {
    qty: number;
    overheadMethod: string;
    overheadPct: number;
    materials: PlanMaterial[];
    stages: PlanStage[];
    totals: {
        material: number;
        /** In-house labour + job work (the order's labour bucket) */
        labour: number;
        inHouseLabour: number;
        jobWork: number;
        /** Machine hours at their hour rate, part of overhead */
        machine: number;
        overheadPercent: number;
        overhead: number;
        total: number;
        perUnit: number;
        plannedMinutes: number;
        labourHours: number;
        qcStages: number;
    };
}

export async function getStandardCostPlan(params: {
    bomId?: string;
    routingId?: string;
    qty: number;
    warehouseId?: string;
}): Promise<ApiResponse<StandardCostPlan>> {
    const query = new URLSearchParams({ qty: String(params.qty) });
    if (params.bomId) query.append('bom_id', params.bomId);
    if (params.routingId) query.append('routing_id', params.routingId);
    if (params.warehouseId) query.append('warehouse_id', params.warehouseId);
    const res = await fetch(`${BASE_URL}/production-orders/standard-cost-plan?${query.toString()}`, {
        method: 'GET',
        headers: getAuthHeaders(),
    });
    return handleResponse<StandardCostPlan>(res);
}
